import "./BasicSetting.scss";
import * as S from "../scss/theme";
import HeaderTitle from "../comm/HeaderTitle";
import React, { useState, useEffect } from "react";
import Combobox from '../comm/Combobox';
// import GangsaTable from './GangsaMain';

import NaverBookMain from "./NaverBookMain";
import { useDispatch } from 'react-redux';
import { setHeaderInfo, setSelectedUnit_pdf } from '../reduxToolkit/redux';
import { setIsAdmin } from '../reduxToolkit/reduxBoard';
import Button  from '../comm/HongButton';
import fnc from "../mymod/commFunction";
import GangsaMain from './GangsaMain';
import GroupMain from './GroupMain';
import ClassMain from './ClassMain';
import Board from "../page_board/Board";


const BasicSetting = () => {
    const dispatch = useDispatch();
    const [optionsUniTable, setOptionsUniTable] = useState([]);
    const [isClickGangsa, setIsClickGangsa] = useState(true);
    const [isClickClass, setIsClickClass] = useState(false);
    const [isClickGroup, setIsClickGroup] = useState(false);
    const [isClickNaverBook, setIsClickNaverBook] = useState(false);
    const [isClickBoard, setIsClickBoard] = useState(false);

    useEffect(() => {   
        const userName = fnc.getCookie('userName');
        dispatch(setHeaderInfo({title: `강사등록`, direction: -1}));
      }, []);


  
    function fncSelectGangsaCombo(acaCode) {
        fnc.sendAxios("/select/class/gangsaList", { acaCode }, (res) => {
          if (res) {     
            // setOptionsByIndex1(res);
       
          } else {
            console.log(res, "속성이 obj 내에 없습니다.");
          }
        });
      }

     
    

     
      //--------------------------------------------------------------2. groupList

  
   
    


  
//-------------------------------------------------3. classList
function fncSelectClassTable(acaCode, groupCode) {
  fnc.sendAxios("/select/class/classList", { acaCode, groupCode }, (res) => {
    if (res) {     
      setOptionsUniTable(res); 
    } else {
      console.log(res, "속성이 obj 내에 없습니다.");
    }
  });
}

function fncSelectGangsa() {
  setIsClickGangsa(true);
  setIsClickClass(false);
  setIsClickGroup(false);
  setIsClickNaverBook(false);
  setIsClickBoard(false);
  dispatch(setHeaderInfo({title: `강사등록`, direction: -1}));
}


function fncSelectGroup() {
  setIsClickGangsa(false);
  setIsClickClass(false);
  setIsClickGroup(true);
  setIsClickNaverBook(false);
  setIsClickBoard(false);
  dispatch(setHeaderInfo({title: `과정등록`, direction: -1}));
}


function fncSelectClass() {
  setIsClickClass(true);
  setIsClickGangsa(false);
  setIsClickGroup(false);
  setIsClickNaverBook(false);
  setIsClickBoard(false);
  dispatch(setHeaderInfo({title: `최종 강좌생성`, direction: -1}));
}

function handleNaverBook() {
  setIsClickClass(false);
  setIsClickGangsa(false);
  setIsClickGroup(false);
  setIsClickNaverBook(true);
  setIsClickBoard(false);
  dispatch(setHeaderInfo({title: `최종 강좌생성`, direction: -1}));
}

function handleBoard() {
  setIsClickClass(false);
  setIsClickGangsa(false);
  setIsClickGroup(false);
  setIsClickNaverBook(false);
  setIsClickBoard(true);
  dispatch(setIsAdmin(true));
}

  //===========================================================
  return (
    <>
      <S.Section>
        {/* <HeaderTitle /> */}
        <div className="BasicSetting">
          <div className="wrap-book">
            <section className="section-btn">
              <article className="article-btn">
                <Button className="btn modern-btn" onClick={fncSelectGangsa}>
                  <i className="fas fa-user-tie"></i>
                  강사등록
                </Button>
                <Button className="btn modern-btn" onClick={fncSelectGroup}>
                  <i className="fas fa-layer-group"></i>
                  과정등록
                </Button>
                <Button className="btn modern-btn" onClick={fncSelectClass}>
                  <i className="fas fa-graduation-cap"></i>
                  최종강좌생성
                </Button>
                <Button className="btn modern-btn" onClick={handleNaverBook}>
                  <i className="fas fa-book"></i>
                  교재등록
                </Button>
                <Button className="btn modern-btn" onClick={handleBoard}>
                  <i className="fas fa-clipboard-list"></i>
                  게시판 작성
                </Button>
              </article>
            </section>
          </div>


          {isClickGangsa && 
            <section className="section-bookMain">
                {isClickGangsa && <GangsaMain/> }
            </section>
          }

          {isClickGroup && 
            <section className="section-bookMain">
                <GroupMain/> 
            </section>
          }

          {isClickClass && 
            <section className="section-bookMain">
                <ClassMain/> 
            </section>
          }

          {isClickNaverBook && 
            <section className="section-bookMain">
                <NaverBookMain/> 
            </section>
          }

          {isClickBoard && 
            <section className="section-bookMain">
                <Board/> 
            </section>
          } 



        </div>
      </S.Section>
    </>
  );
};

export default BasicSetting;
